<template>
  <card>
    <template class="card-header" slot="header">
      <h4 class="card-title">
        License Information
        <button v-if="!noRefresh" class="btn btn-link text-info pull-right" @click="$emit('refreshData')">
          <font-awesome-icon icon="sync"></font-awesome-icon>
        </button>
      </h4>
      <p class="card-category">License limits and current usage.</p>
    </template>
    <table class="table table-borderless beast-info-table">
      <tr>
        <th class="beast-key">Expires:</th>
        <td class="beast-value">{{licenseInfo.limits.endDate}}</td>
      </tr>
      <tr>
        <th class="beast-key">Users:</th>
        <td class="beast-value">{{licenseInfo.usage.users}} / {{formatLimit(licenseInfo.limits.users)}}</td>
      </tr>
      <tr>
        <th class="beast-key">Packages:</th>
        <td class="beast-value">
          {{licenseInfo.usage.packages.total}} / {{formatLimit(licenseInfo.limits.packages.total)}}
        </td>
      </tr>
      <tr>
        <th class="beast-key">Organizations:</th>
        <td class="beast-value">
          {{licenseInfo.usage.organizations}} / {{formatLimit(licenseInfo.limits.organizations)}}
        </td>
      </tr>
      <tr>
        <th class="beast-key">Packages without org:</th>
        <td class="beast-value">
          {{licenseInfo.usage.packages.without}} / {{formatLimit(licenseInfo.limits.packages.without)}}
        </td>
      </tr>
      <tr>
        <th class="beast-key">Packages with org:</th>
        <td class="beast-value">
          {{licenseInfo.usage.packages.with}} / {{formatLimit(licenseInfo.limits.packages.with)}}
        </td>
      </tr>
    </table>
  </card>
</template>

<script>
export default {
  name: "LicenseInfo",
  props: {
    licenseInfo: {
      type: Object,
      required: true
    },
    noRefresh: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatLimit(limit) {
      return limit < 0 ? "Unlimited" : limit;
    }
  }
};
</script>

<style scoped>

</style>
